export default "__VITE_ASSET__DinVO$r6__"